import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import MembershipCard from '../components/MembershipCard';
import { useAuth } from '../hooks/useAuth';

const Membership = () => {
  const { user } = useAuth();

  // Datos de ejemplo de la membresía
  const membershipData = {
    name: user?.name || "Usuario",
    level: "BRONZE",
    membershipId: "6489722",
    status: "Active",
    points: 150,
    avatarUrl: user?.picture
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ 
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 200px)'
      }}>
        <MembershipCard memberInfo={membershipData} />
      </Box>
    </Container>
  );
};

export default Membership;
